import log, { RootLogger } from 'loglevel';
import { getAppVersion } from '@/utils/general.ts';
import { logsCollectorMiddleware } from './logs-collector.middleware.ts';
import { logFormatterMiddleware } from './log-formatter.middleware.ts';
import { consoleLogMiddleware } from './console-log.middleware';

export type ScopedLogger = {
  trace: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
};

export const createScopedLogger = (baseLogger: log.Logger, context: Record<string, unknown>): ScopedLogger => ({
  trace: (...args: unknown[]) => baseLogger.trace(...args, context),
  debug: (...args: unknown[]) => baseLogger.debug(...args, context),
  info: (...args: unknown[]) => baseLogger.info(...args, context),
  warn: (...args: unknown[]) => baseLogger.warn(...args, context),
  error: (...args: unknown[]) => baseLogger.error(...args, context),
});

let initialized = false;

export const initLogger = (logger: RootLogger): void => {
  // todo: env var
  logger.setLevel('debug');

  const appVersion = getAppVersion() || 'NA';

  // middleware executed in a reverse order
  consoleLogMiddleware(logger);
  logsCollectorMiddleware(logger, appVersion);
  logFormatterMiddleware(logger, appVersion);

  initialized = true;
};

if (!initialized) {
  initLogger(log);
}

export { log };
